<script setup lang="ts">
import type { StopoverDetail } from '@optionway/models';

const selectedCorrespondence = defineProps<StopoverDetail>();

const { loading } = useSearchResultsQueryState();

const prefix = 'components.results.bottomCorrespondence';

const locationLabelsStore = useLocationLabels();
</script>

<template>
  <div class="inline-flex items-center justify-start gap-2.5 self-stretch py-1">
    <UiSkeleton
      v-if="loading"
      class="h-12 w-full rounded-xl"
    />
    <div
      v-else
      class="flex flex-1 items-center justify-start gap-2 rounded-xl border pl-2 pr-2.5"
      :class="
        selectedCorrespondence.displayType === 'WARNING'
          ? 'border-orange-200 bg-orange-50'
          : 'border-light-blue-200 bg-light-blue-50'
      "
    >
      <div class="flex h-8 items-center justify-center gap-2.5 rounded p-2">
        <SvgoResultsConnection
          :class="selectedCorrespondence.displayType === 'WARNING' ? 'text-orange-700' : 'text-light-blue-700'"
          filled
          :font-controlled="false"
        />
      </div>
      <i18n-t
        v-if="selectedCorrespondence.changeType === 'AIRPORT'"
        scope="global"
        :keypath="`${prefix}.correspondenceToAirportChange`"
        tag="div"
        class="text-xs font-normal leading-normal text-foreground md:text-sm"
      >
        <template #duration>{{ useDurationFormat(selectedCorrespondence.duration) }}</template>
        <template #city>{{ locationLabelsStore.city(selectedCorrespondence.location?.cityIataCode) }}</template>
      </i18n-t>
      <div
        v-else
        class="flex items-center gap-2"
      >
        <div class="justify-start text-xs font-normal leading-normal text-foreground md:text-sm">
          {{ $t(`${prefix}.correspondence`, { duration: useDurationFormat(selectedCorrespondence.duration) }) }}
        </div>
        <div class="h-1 w-1 shrink-0 rounded-full bg-foreground" />
        <div class="justify-start text-xs font-normal leading-normal text-foreground md:text-sm">
          {{ locationLabelsStore.city(selectedCorrespondence.location?.cityIataCode) }}
        </div>
      </div>
    </div>
  </div>
</template>
